export type WorkspaceHeaderCollapseState = {
  progress: number;
  heroTranslateY: number;
  heroOpacity: number;
  heroBlur: number;
  compactTitleOpacity: number;
  compactTitleTranslateY: number;
  compactMetaOpacity: number;
  compactMetaTranslateY: number;
  chromeOpacity: number;
};

const clamp = (value: number, minimum: number, maximum: number): number =>
  Math.min(maximum, Math.max(minimum, value));

/** Pure scroll-linked values shared by the completed-workspace chrome. */
export function workspaceHeaderCollapseState(
  scrollTop: number,
  heroHeight: number,
  reducedMotion = false,
): WorkspaceHeaderCollapseState {
  const range = Math.max(140, heroHeight - 54);
  const progress = clamp(scrollTop / range, 0, 1);
  const entrance = clamp((progress - 0.34) / 0.66, 0, 1);
  const ease = 1 - (1 - entrance) ** 3;
  const titleRise = reducedMotion ? 8 : 24;

  return {
    progress,
    heroTranslateY: reducedMotion ? 0 : -scrollTop * 0.34,
    heroOpacity: clamp(1 - progress * 0.95, 0, 1),
    heroBlur: reducedMotion ? 0 : progress * 7,
    compactTitleOpacity: ease,
    compactTitleTranslateY: (1 - ease) * titleRise,
    compactMetaOpacity: ease * 0.95,
    compactMetaTranslateY: (1 - ease) * titleRise * 0.7,
    chromeOpacity: 1,
  };
}
